import React from 'react';
import WaringGif from '../../images/warning-yellow.gif'
import "./Success&ErrorPopups.css"
import { Button, Modal, ModalBody } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { warningModalToggle } from '../../redux/actions/Index';
import { useForm } from 'react-hook-form';

function WarningPopup({ deleteData, customMessage, tenant }) {
    const dispatch = useDispatch()
    const warningpopup = useSelector((state) => state?.ModalReducer?.warningToggle);
    const deletableId = useSelector((state) => state?.ModalReducer?.deleteableId);

    const {
        register,
        watch,
        reset,
        formState: { errors },
    } = useForm();

    let input = watch('input')

    return (
        <div>
            <Modal isOpen={warningpopup} className="modal-style">
                <ModalBody className="py-3">
                    <div className="d-flex justify-content-center align-items-center flex-column gap-1">
                        <div className="cards-img mb-5">
                            <img src={WaringGif} alt="Success Gif" className="img-fit" />
                        </div>
                        <h1 className="title-font-bold fs-1 mb-2 text-uppercase text-base-yellow ">Warning !</h1>
                        <p className="text-base-yellow mb-4 fs-6">
                            {customMessage === undefined ? "Press Ok to continue..." : customMessage}
                        </p>
                        {
                            tenant == true &&
                            <input
                                className='warning-border-10 w-100 fs-4 p-2 mb-5'
                                placeholder='delete'
                                {...register('input')}
                            />
                        }
                        <div className="d-flex justify-content-between align-items-center gap-4">
                            <Button className='rounded-pill px-5 py-3 popup-buttons-gray' onClick={() => { dispatch(warningModalToggle()); reset({ input: "" }) }} ><span className='fs-3 d-flex gap-3 title-font-400 '>Cancel</span></Button>
                            <Button className='rounded-pill px-5 py-3 popup-buttons-warning' disabled={tenant ? input != 'delete' : false} onClick={() => { deleteData(deletableId); reset({ input: "" }) }} ><span className='fs-3 d-flex gap-3 title-font-400 '>Ok</span></Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default WarningPopup;
